/* eslint-disable */
/**
 *  ajax统一请求方法
 *  @param { String } path 请求路由url 允许使用动态匹配
 *  @example request('/auth/user/:id/')
 *  @param { Object } options 请求参数
 *  @param { String } options.method 请求方式
 *  @param { Object } options.params 请求携带参数，包含动态匹配的参数
 *
 *  @param.headers 中自定义配置项：
 *                                 'Cancel-Message'     是否取消统一报错提示
 *
 *  @return { Object } 返回axios promise对象
 */

import { Message } from 'element-ui';
import axios from 'axios';
import store from '../store';
import { lodashUtils, getUserAgent, createUuid } from '../utils';
// 401报错去重
let timeId = null;

function queryJoin(url, key, value) {
    let newUrl = url;
    if (newUrl.indexOf('?') > -1) {
        newUrl += '&';
    } else {
        newUrl += '?';
    }
    newUrl += `${key}=${(value)}`;
    return newUrl;
}

function paramsToQueryString(url, params) {
    // 目前只转换以下值类型：Array, Number, String
    let newUrl = url;
    if (!lodashUtils.cloneDeep(params)) {
        throw new Error('params must Object!!');
    }
    if (lodashUtils.isObject(params) && !lodashUtils.isEmpty(params)) {
        for (const key in params) {
            if (lodashUtils.isArray(params[key])) {
                // eslint-disable-next-line
                params[key].forEach((val) => {
                    newUrl = queryJoin(newUrl, key, encodeURIComponent(val));
                });
            } else {
                newUrl = queryJoin(newUrl, key, encodeURIComponent(params[key]));
            }
        }
    }
    return newUrl;
}

function replaceQuery(path, options) {
    // 删除为null或者undefined的非法参数
    if (lodashUtils.isObject(options.params)) {
        Object.keys(options.params).forEach((att) => {
            if (options.params[att] === null || options.params[att] === undefined) delete options.params[att];
        });
    }

    // 动态匹配参数替换
    let url = path.replace(/:(.*?)(\/|\?| )/g, (a, b, c) => {
        const value = options.params[b];
        delete options.params[b];
        return `${value}${c}`;
    }).trim();
    if (options.method === 'GET') {
        // 如果是GET请求，将对应参数转化为query params
        if (options.params) {
            url = paramsToQueryString(url, options.params);
        }
    }
    return url;
}

axios.interceptors.request.use(config => config, (error) => {
    throw new Error(error);
});

axios.interceptors.response.use(
    async (response) => {
        // 导出文件流
        if (response.data instanceof Blob) {
            if (response.data.type.includes('application/octet-stream') || response.data.type === 'application/ms-excel') {
                const origin = response.headers['content-disposition'];
                const originFilename = origin.split('; ').filter(ele => ele.indexOf('filename') !== -1);
                let filename = '';
                if (originFilename && originFilename.length > 0) {
                    filename = originFilename[0].split('=')[1].replace(/"/g, '');
                }
                return {
                    blob: response.data,
                    filename,
                };
            }
            if (response.data.type === 'application/json') {
                // 默认导出错误提示
                let exportErrorMsg = '导出失败';
                // 导出失败，转换为JSON
                const fr = new FileReader();
                fr.readAsText(response.data, 'utf-8');
                fr.onload = () => {
                    try {
                        exportErrorMsg = JSON.parse(fr.result).msg;
                    } catch (e) {
                        throw new Error(e);
                    } finally {
                        Message.error({
                            message: exportErrorMsg,
                            duration: 3000,
                        });
                    }
                };
                fr.onerror = () => {
                    Message.error({
                        message: exportErrorMsg,
                        duration: 3000,
                    });
                };
                return Promise.reject();
            }
        }
        // 目前后端组规范将所有请求统一返回200，以code字段表示真实http状态码
        const { code, msg } = response.data;
        const { config } = response;
        const delayTime = 3 * 1000;

        //返回所有值，自己处理返回数据
        if (config.fullRes) {
            return response.data;
        }
        // 拦截数据导出统一提示
        // if (response.headers['content-type'] === "application/octet-stream") {
        //     // if (response.data.type === 'application/octet-stream') {
        //         Message({
        //             message: '数据导出成功!',
        //             type: 'success',
        //             duration: delayTime,
        //         });
        //         return response;
        //     // }

        //     // 默认导出错误提示
        //     let exportErrorMsg = '数据导出失败!';

        //     // 导出失败，转换为JSON
        //     const fr = new FileReader();
        //     fr.readAsText(response.data, 'utf-8');
        //     fr.onload = function () {
        //         try {
        //             exportErrorMsg = JSON.parse(this.result).msg;
        //         } catch (e) {
        //             throw e;
        //         } finally {
        //             Message({
        //                 message: exportErrorMsg,
        //                 type: 'error',
        //                 duration: delayTime,
        //             });
        //         }
        //     };
        //     fr.onerror = function () {
        //         Message({
        //             message: exportErrorMsg,
        //             type: 'error',
        //             duration: delayTime,
        //         });
        //     };

        //     return Promise.reject();
        // }
        // if (typeof response.data === 'string') {
        //     response.data = JSON.parse(response.data);
        // }

        if (code !== 0) {
            if (!config.headers['Cancel-Message']) {
                Message({
                    message: msg,
                    type: 'error',
                    duration: delayTime,
                });
            }
            setTimeout(() => {
                if (code === 401) store.dispatch('user/LogOut', 'locale');
            }, delayTime);

            return Promise.reject(response);
        }

        return response.data;
    },
    async (error) => {
        const { config } = error;
        const delayTime = 3 * 1000;

        if (error.response && error.response.status === 401) {
            if (!timeId) {
                timeId = setTimeout(() => {
                    Message({
                        message: '你已登出凯励程CRM系统',
                        type: 'error',
                        duration: delayTime,
                    });
                }, 0);

                setTimeout(() => {
                    store.dispatch('user/LogOut', 'locale');
                }, delayTime);
            }
        } else if (!config.headers['Cancel-Message']) {
            if (error.message === 'Network Error') {
                Message({
                    message: '无法获取页面内容，请检查您的网络',
                    type: 'error',
                    duration: delayTime,
                });
            } else {
                Message({
                    message: error.message,
                    type: 'error',
                    duration: delayTime,
                });
            }
        } else {
            throw error;
        }

        return Promise.reject(error);
    },
);

const exportRequest = (path, options = {
    method: 'GET',
}) => {
    // 由于引用数据类型按共享传递，进行配置项深拷贝
    const opt = lodashUtils.cloneDeep(options);
    opt.method = opt.method.toUpperCase();
    const baseURL = path.indexOf('auth_service') >= 0 || path.indexOf('/api/') >= 0 || path.indexOf('gaia') >= 0 ? '' : '/api/saas';

    const axiosConfig = {
        url: replaceQuery(path, opt),
        method: opt.method,
        data: opt.params,
        baseURL,
        headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json; charset=UTF-8',
            // 设备指纹
            'Klicen-Agent': getUserAgent(),
            // 接口指纹
            'X-TRACE-ID': createUuid(),

            ...opt.headers,
        },
        // 请求超时时间
        timeout: opt.timeout || (120 * 1000),
        responseType: opt.responseType,
        fullRes: opt.fullRes || false,
    };
    return axios(axiosConfig);
};

window.request = exportRequest;
export default exportRequest;
